module.exports = {"success":"","version":"0.0.1","list":[{"id":"","name":"全部"},{"id":"45","name":"新石器时代"},{"id":"48","name":"商"},{"id":"49","name":"周"},{"id":"50","name":"西周"},{"id":"51","name":"东周"},{"id":"55","name":"汉"},{"id":"56","name":"西汉"},{"id":"57","name":"东汉"},{"id":"79","name":"唐"},{"id":"87","name":"宋"},{"id":"93","name":"元"},{"id":"94","name":"明"},{"id":"95","name":"清"},{"id":"96","name":"民国"},{"id":"97","name":"中华人民共和国"}]}


//////////////////
// WEBPACK FOOTER
// ./static/dataJson/collectionYear.json
// module id = ydSE
// module chunks = 1